export default "https://assets-v2.scaler.com/packs/files/post-solving-heading.98cb42.webp";